export default "__VITE_ASSET__c6508691__"